module.exports = __webpack_public_path__ + "static/media/madagascar_traditional_fishing_pirogue.2ceaef4d.jpg";